const { Http } = require('./httpService')

class OAuthIdentity {
    access_token;
    id_token;

    setAccessToken(token) {
        this.access_token = token;
    }
    setIDToken(token) {
        this.id_token = token;
    }
    getAccessToken() {
        return this.access_token;
    }
    getIDToken() {
        return this.id_token;
    }
}

class AuthContext {
    static DENIED = 'denied';
    static NOT_DENIED = 'not_determined';
    static AUTHORIZED = 'authorized';
    consent;

    setConsent(consent) {
        this.consent = consent;
    }
    getConsent() {
        return this.consent;
    }
}

class AuthService {
    static PROVIDER_FACEBOOK = 'facebook';
    static PROVIDER_APPLE = 'apple';
    static PROVIDER_GOOGLE = 'google';

    constructor({
                    authTokenKey = 'auth_token',
                    refreshTokenKey = 'refresh_token',
                    apiKey,
                }) {
        this.authTokenKey = authTokenKey;
        this.refreshTokenKey = refreshTokenKey;
        this.authToken = null;
        this.refreshToken = null;
        this.baseURL = 'https://auth.platforms.team';
        this.apiKey = apiKey;
        this.http = new Http();
    }

    store({ authToken, refreshToken }) {
        this.authToken = authToken;
        this.refreshToken = refreshToken;
    }


    overrideBaseUrl(baseURL) {
        this.baseURL = baseURL;
    }

    clear() {
        this.authToken = null;
        this.refreshToken = null;
    }

    signUpWithEmailPassword({
        email,
        password
    }) {
        return this.http.post(`${this.baseURL}/api/register`, {
            email,
            password
        }, {
            'X-API-KEY': this.apiKey
        });
    }

    signInWithEmailPassword({ username, password }) {
        return this.http.post(`${this.baseURL}/api/login_check`, {
            username,
            password
        }, {
            'X-API-KEY': this.apiKey,
            'Content-Type': 'application/json'
        })
            .then((data) => {
                this.store(
                    {
                        authToken: data.token,
                        refreshToken: data.refresh_token
                    }
                );
                return data;
            });
    }

    deleteUserAccount() {
        return this.http.delete(`${this.baseURL}/api/user`, {}, {
            'X-API-KEY': this.apiKey
        }).then((res) => {
            this.clear();
            return res;
        });
    }

    refreshToken() {
        return this.http.post(`${this.baseURL}/api/token/refresh`, {
            refresh_token: this.refreshToken
        }, {
            'X-API-KEY': this.apiKey
        })
            .then((data) => {
                this.authToken = data.authToken;
                this.refreshToken = data.refreshToken;
                return data;
            });
    }

    resetPassword({
                      password,
                      token
                  }) {
        return this.http.post(`${this.baseURL}/api/reset/password`, {
            token,
            password: password
        }, {
            'X-API-KEY': this.apiKey
        });
    }

    forgotPassword(email) {
        this.http.post(`${this.baseURL}/api/forgot/password`, {
            email: email
        }, {
            'X-API-KEY': this.apiKey
        });
    }

    getUser(decode) {
        const token = decode(this.authToken);
        const { user } = token;
        return user;
    }

    getRegion() {
        return this.http.get(`${this.baseURL}/api/consent/region`, {
            'Content-Type': 'application/json'
        });
    }

    sendEmail({ email, data_collection_consent }) { // eslint-disable-line camelcase
        return this.http.post(`${this.baseURL}/api/consent/email`, {
            email,
            data_collection_consent
        }, {
            'X-API-KEY': this.apiKey
        });
    }

    signInWithOAuth(provider, oAuthIdentity, context) {
        return this.http.post(`${this.baseURL}/api/login_check_oauth`, {
            type: provider,
            id_token: oAuthIdentity.getIDToken(),
            access_token: oAuthIdentity.getAccessToken(),
            data_collection_consent: context.getConsent(),
        }, {
            'X-API-KEY': this.apiKey
        })
            .then((data) => {
                this.store(
                    {
                        authToken: data.token,
                        refreshToken: data.refresh_token
                    }
                );
                return data;
            });
    }
}

module.exports = {
    AuthSDK: AuthService,
    OAuthIdentity: OAuthIdentity,
    AuthContext: AuthContext
};